// OrderStatusBadge.tsx
import React from 'react';
import { Badge } from '@chakra-ui/react';
import { OrderStatus, defaultStatus, orderStatusMap } from '../../../constants/statusConfig';

interface OrderStatusBadgeProps {
  status: OrderStatus | number;
}

const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({ status }) => {
  const { text, colorScheme } = orderStatusMap[status as OrderStatus] || defaultStatus;

  return (
    <Badge colorScheme={colorScheme} px={4} py={1} borderRadius="md" fontSize="11px" maxH={'20px'}>
      {text}
    </Badge>
  );
};

export default OrderStatusBadge;
